import { type ReactNode, type Ref } from 'react';

import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerProps,
  Typography,
  Box,
  tokens,
} from '@cast/design-system';

export type ManifestDrawerBaseProps = {
  title: string;
  children: ReactNode;
};

type Props = DrawerProps &
  ManifestDrawerBaseProps & {
    ref?: Ref<HTMLDivElement>;
  };

export const ManifestDrawer = ({
  ref,
  title,
  children,
  ...drawerProps
}: Props) => {
  return (
    <Drawer ref={ref} size="large" testId="manifest-drawer" {...drawerProps}>
      <DrawerHeader />
      <DrawerBody
        sx={{
          bgcolor: tokens.theme.bg.structural.surfaceInverse,
          minHeight: '100%',
        }}
      >
        <DrawerContent>
          <Typography variant="h5" mb={16}>
            {title}
          </Typography>
          <Box>{children}</Box>
        </DrawerContent>
      </DrawerBody>
    </Drawer>
  );
};
